import React from 'react';
import { SecondaryNavIdentifier } from '@zola-helpers/client/dist/types/constants/navConstants';
import type { WCategoryView } from '@zola/svc-web-api-ts-client';

import { ShopHeader } from './ShopHeader';

import { NAV_DATA } from '../../../../components/common/header/UnifiedNavV2';

const { NEW_ARRIVALS, COLLECTIONS, BRANDS } = NAV_DATA.SECONDARY.REGISTRY;

type HeaderProps = {
  aboveBannerContent: React.ReactNode;
  metaData?: {
    title?: string;
    description?: string;
  };
  categoryFilter: WCategoryView[] | null;
  weddingNavKey: string;
  showBanner?: boolean;
  collectionKey?: string;
  brandKey?: string;
};

export const getNavProps = ({
  weddingNavKey,
  categoryFilter,
  collectionKey,
  brandKey,
}: {
  weddingNavKey: string | null;
  categoryFilter: WCategoryView[] | null;
  collectionKey?: string;
  brandKey?: string;
}) => {
  const activePrimaryLink = weddingNavKey
    ? NAV_DATA.PRIMARY.WEDDING_BOUTIQUE
    : NAV_DATA.PRIMARY.REGISTRY;

  let activeSecondaryLink: SecondaryNavIdentifier | undefined =
    categoryFilter && categoryFilter.length
      ? (categoryFilter[0].key as SecondaryNavIdentifier)
      : undefined;

  if (!activeSecondaryLink && collectionKey) {
    activeSecondaryLink = collectionKey === NEW_ARRIVALS ? NEW_ARRIVALS : COLLECTIONS;
  }
  if (collectionKey === 'wedding-shop-new-arrivals') activeSecondaryLink = NEW_ARRIVALS;
  if (brandKey) activeSecondaryLink = BRANDS;

  return {
    activePrimaryLink,
    activeSecondaryLink,
    activeTertiaryLink: activeSecondaryLink,
  };
};

export const Header = (props: HeaderProps) => {
  const {
    aboveBannerContent,
    metaData,
    categoryFilter,
    weddingNavKey,
    showBanner = true,
    collectionKey,
    brandKey,
  } = props;

  return (
    <ShopHeader
      aboveBannerContent={aboveBannerContent}
      metaData={metaData}
      {...getNavProps({ categoryFilter, weddingNavKey, collectionKey, brandKey })}
      isWeddingBoutiquePage={weddingNavKey}
      showBanner={showBanner}
    />
  );
};
